import { useParams } from "hooks";
import { useMemo } from "react";
import { insuranceTypeNames } from "constants/defaultValues";

export const useInsuranceTypeConfiguration = insuranceTypes => {
  const insuranceTypeConfigurationJSON = useParams("InsuranceTypeConfiguration");

  const insuranceConfigurations = useMemo(() => {
    if (insuranceTypeConfigurationJSON) return JSON.parse(insuranceTypeConfigurationJSON);
  }, [insuranceTypeConfigurationJSON]);

  let rcaInsuranceTypeConfiguration = null,
    cascoInsuranceTypeConfiguration = null,
    rtiInsuranceTypeConfiguration = null;

  if (insuranceTypes.includes(insuranceTypeNames.RCA))
    rcaInsuranceTypeConfiguration = insuranceConfigurations?.find(x => x.InsuranceTypeName === insuranceTypeNames.RCA);

  if (insuranceTypes.includes(insuranceTypeNames.CASCO))
    cascoInsuranceTypeConfiguration = insuranceConfigurations?.find(
      x => x.InsuranceTypeName === insuranceTypeNames.CASCO
    );

  if (insuranceTypes.includes(insuranceTypeNames.RTI))
    rtiInsuranceTypeConfiguration = insuranceConfigurations?.find(x => x.InsuranceTypeName === insuranceTypeNames.RTI);

  return { rcaInsuranceTypeConfiguration, cascoInsuranceTypeConfiguration, rtiInsuranceTypeConfiguration };
};
